import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import Component from "@reactions/component";
import { Pane, Dialog } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import Login from '../common/login';
import { Link } from 'react-router-dom';

const cookies = new Cookies();

// ============================================
// RESPONSIVE LIGHT THEME
// ============================================
const styles = {
    container: {
        minHeight: '100vh',
        background: '#f1f5f9',
        padding: '24px',
        fontFamily: "'Tajawal', sans-serif",
        direction: 'rtl',
    },

    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '12px',
    },

    pageTitle: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },

    createButton: {
        background: '#2563eb',
        border: 'none',
        borderRadius: '10px',
        padding: '12px 24px',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
    },

    statsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '12px',
        marginBottom: '20px',
    },

    statCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: '1px solid #e2e8f0',
        textAlign: 'center',
    },

    statValue: {
        fontSize: '26px',
        fontWeight: '700',
        marginBottom: '2px',
        lineHeight: 1.2,
    },

    statLabel: {
        fontSize: '12px',
        color: '#64748b',
        fontWeight: '500',
    },

    // Filter Section
    filterSection: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: '1px solid #e2e8f0',
    },

    filterHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
    },

    filterTitle: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#0f172a',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },

    filterToggle: {
        background: '#f1f5f9',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '6px 14px',
        color: '#2563eb',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
    },

    filterGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '12px',
    },

    filterGroup: {
        background: '#f8fafc',
        borderRadius: '8px',
        padding: '12px',
        border: '1px solid #e2e8f0',
    },

    filterGroupTitle: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#2563eb',
        marginBottom: '8px',
        paddingBottom: '6px',
        borderBottom: '1px solid #e2e8f0',
    },

    filterOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '5px 4px',
        cursor: 'pointer',
        borderRadius: '6px',
        transition: 'background 0.15s',
    },

    checkbox: {
        width: '16px',
        height: '16px',
        borderRadius: '4px',
        border: '2px solid #cbd5e1',
        background: '#fff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.15s',
        flexShrink: 0,
    },

    checkboxChecked: {
        background: '#2563eb',
        border: '2px solid #2563eb',
    },

    filterLabel: {
        fontSize: '13px',
        color: '#475569',
    },

    filterActions: {
        display: 'flex',
        gap: '10px',
        marginTop: '14px',
        justifyContent: 'center',
        paddingTop: '14px',
        borderTop: '1px solid #e2e8f0',
    },

    applyButton: {
        background: '#2563eb',
        border: 'none',
        borderRadius: '8px',
        padding: '9px 24px',
        color: '#fff',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
    },

    resetButton: {
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        padding: '9px 20px',
        color: '#64748b',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },

    supplierList: {
        maxHeight: '160px',
        overflowY: 'auto',
    },

    // Desktop Table
    tableContainer: {
        background: '#fff',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: '1px solid #e2e8f0',
    },

    tableWrapper: {
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
    },

    table: {
        width: '100%',
        borderCollapse: 'collapse',
        minWidth: '700px',
    },

    th: {
        padding: '12px 14px',
        textAlign: 'right',
        fontSize: '11px',
        fontWeight: '600',
        color: '#64748b',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        borderBottom: '1px solid #e2e8f0',
        background: '#f8fafc',
        whiteSpace: 'nowrap',
    },

    tr: {
        borderBottom: '1px solid #f1f5f9',
        transition: 'background 0.15s',
    },

    td: {
        padding: '12px 14px',
        fontSize: '13px',
        color: '#334155',
    },

    // Status Badges
    badge: {
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '16px',
        fontSize: '11px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
    },

    badgeSuccess: { background: '#dcfce7', color: '#16a34a' },
    badgeWarning: { background: '#fef3c7', color: '#d97706' },
    badgeError: { background: '#fee2e2', color: '#dc2626' },
    badgeInfo: { background: '#dbeafe', color: '#2563eb' },

    // Action Buttons
    actionButton: {
        background: '#eff6ff',
        border: '1px solid #bfdbfe',
        borderRadius: '6px',
        padding: '6px 10px',
        color: '#2563eb',
        fontSize: '12px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
        textDecoration: 'none',
    },

    closeButton: {
        background: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '6px',
        padding: '6px 10px',
        color: '#dc2626',
        fontSize: '12px',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
    },

    // Mobile Card Layout
    mobileCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '14px',
        marginBottom: '10px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
    },

    mobileCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
        paddingBottom: '10px',
        borderBottom: '1px solid #f1f5f9',
    },

    mobileCardId: {
        fontWeight: '700',
        color: '#2563eb',
        fontSize: '14px',
    },

    mobileCardBody: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px',
    },

    mobileCardField: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },

    mobileCardLabel: {
        fontSize: '11px',
        color: '#94a3b8',
        fontWeight: '500',
    },

    mobileCardValue: {
        fontSize: '13px',
        color: '#1e293b',
        fontWeight: '500',
    },

    mobileCardActions: {
        display: 'flex',
        gap: '8px',
        marginTop: '12px',
        paddingTop: '10px',
        borderTop: '1px solid #f1f5f9',
    },

    // Pagination
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        padding: '16px',
        background: '#f8fafc',
        borderTop: '1px solid #e2e8f0',
        flexWrap: 'wrap',
    },

    pageButton: {
        width: '34px',
        height: '34px',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
        background: '#fff',
        color: '#64748b',
        fontSize: '13px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    pageButtonActive: {
        background: '#2563eb',
        border: '1px solid #2563eb',
        color: '#fff',
    },

    pageInfo: {
        color: '#64748b',
        fontSize: '12px',
        margin: '0 8px',
    },

    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '50px',
    },

    spinner: {
        width: '36px',
        height: '36px',
        border: '3px solid #e2e8f0',
        borderTop: '3px solid #2563eb',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },

    emptyState: {
        textAlign: 'center',
        padding: '40px 20px',
        color: '#94a3b8',
    },

    radioGroup: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        padding: '12px 0',
        flexWrap: 'wrap',
    },

    radioOption: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '10px 16px',
        background: '#f8fafc',
        borderRadius: '8px',
        cursor: 'pointer',
        border: '2px solid #e2e8f0',
        transition: 'all 0.15s',
    },

    radioOptionSelected: {
        background: '#eff6ff',
        border: '2px solid #2563eb',
    },
};

const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;600;700&display=swap');
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(6px); }
        to { opacity: 1; transform: translateY(0); }
    }
    
    .table-row:hover { background: #f8fafc !important; }
    .filter-option:hover { background: #f1f5f9; }
    .action-btn:hover { opacity: 0.85; }
    .page-btn:hover:not(.active) { background: #f1f5f9; }
    .create-btn:hover { box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4); }
    
    /* Mobile Responsive */
    @media (max-width: 768px) {
        .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 8px !important;
        }
        .stats-grid .stat-card {
            padding: 12px !important;
        }
        .stats-grid .stat-value {
            font-size: 20px !important;
        }
        .filter-grid-responsive {
            grid-template-columns: 1fr 1fr !important;
            gap: 8px !important;
        }
        .desktop-table { display: none !important; }
        .mobile-cards { display: block !important; }
        .page-container {
            padding: 14px !important;
        }
        .page-title-text {
            font-size: 20px !important;
        }
        .create-btn {
            padding: 10px 16px !important;
            font-size: 13px !important;
        }
        .pagination-wrap {
            gap: 3px !important;
            padding: 12px 8px !important;
        }
        .pagination-wrap .page-btn {
            width: 30px !important;
            height: 30px !important;
            font-size: 12px !important;
        }
    }
    
    @media (max-width: 480px) {
        .filter-grid-responsive {
            grid-template-columns: 1fr !important;
        }
        .stats-grid {
            grid-template-columns: repeat(2, 1fr) !important;
        }
    }
    
    ::-webkit-scrollbar { width: 5px; height: 5px; }
    ::-webkit-scrollbar-track { background: #f1f5f9; }
    ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
`;

// ============================================
// ICONS
// ============================================
const Icons = {
    Filter: () => (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
    ),
    Plus: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
    ),
    Info: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
    ),
    Close: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
    ),
    Check: () => (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    ),
    ChevronLeft: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
    ),
    ChevronRight: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
    ),
    ChevronsLeft: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="11 17 6 12 11 7"></polyline>
            <polyline points="18 17 13 12 18 7"></polyline>
        </svg>
    ),
    ChevronsRight: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="13 17 18 12 13 7"></polyline>
            <polyline points="6 17 11 12 6 7"></polyline>
        </svg>
    ),
    FileText: () => (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
        </svg>
    ),
    Refresh: () => (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 4 23 10 17 10"></polyline>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>
    ),
    Receipt: () => (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
            <path d="M4 2v20l3-2 3 2 3-2 3 2 3-2 3 2V2l-3 2-3-2-3 2-3-2-3 2-3-2z"></path>
            <line x1="8" y1="10" x2="16" y2="10"></line>
            <line x1="8" y1="14" x2="12" y2="14"></line>
        </svg>
    ),
};

// ============================================
// MAIN COMPONENT
// ============================================
class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bills: [],
            loading: false,
            suppliers: [],
            currentPage: 1,
            totalPages: 1,
            total: 0,
            limit: 50,
            filters: {
                supplier_name: [],
                type: [],
                sana: [],
                status: [0],
                is_closed: []
            },
            showFilters: true,
            selectedBillType: '1',
            isMobile: window.innerWidth <= 768,
        };
    }

    componentDidMount() {
        const styleSheet = document.createElement("style");
        styleSheet.innerText = globalStyles;
        document.head.appendChild(styleSheet);

        window.addEventListener('resize', this.handleResize);
        this.fetchSuppliers();
        this.fetchBills(1);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 768 });
    }

    fetchSuppliers = () => {
        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `dashbord/suppliers/names`, { headers: header })
            .then(res => this.setState({ suppliers: res.data.suppliers || [] }))
            .catch(error => console.log(error));
    }

    buildQueryString = () => {
        const { filters } = this.state;
        let params = [];
        Object.keys(filters).forEach(key => {
            filters[key].forEach(value => {
                params.push(`${key}=${encodeURIComponent(value)}`);
            });
        });
        return params.join('&');
    }

    fetchBills = (page) => {
        this.setState({ loading: true });
        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        const filterQuery = this.buildQueryString();
        const url = `${host}dashbord/biils/all/?page=${page}&limit=${this.state.limit}${filterQuery ? '&' + filterQuery : ''}`;

        axios.get(url, { headers: header })
            .then(res => {
                this.setState({
                    bills: res.data.bills || [],
                    loading: false,
                    currentPage: res.data.pagination?.page || 1,
                    totalPages: res.data.pagination?.totalPages || 1,
                    total: res.data.pagination?.total || 0,
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                toast.error('حدث خطأ في جلب البيانات');
            });
    }

    handleFilterChange = (filterType, value) => {
        const { filters } = this.state;
        const currentValues = [...filters[filterType]];
        const index = currentValues.indexOf(value);
        if (index > -1) currentValues.splice(index, 1);
        else currentValues.push(value);
        this.setState({ filters: { ...filters, [filterType]: currentValues } });
    }

    applyFilters = () => {
        this.setState({ currentPage: 1 });
        this.fetchBills(1);
    }

    resetFilters = () => {
        this.setState({
            filters: { supplier_name: [], type: [], sana: [], status: [0], is_closed: [] },
            currentPage: 1
        }, () => this.fetchBills(1));
    }

    handlePageChange = (page) => {
        this.setState({ currentPage: page });
        this.fetchBills(page);
    }

    updateList = (id) => {
        const header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.post(host + `dashbord/list/close/${id}`, {}, { headers: header })
            .then(() => {
                toast.success("تم غلق القائمة بنجاح");
                this.fetchBills(this.state.currentPage);
            })
            .catch(error => {
                console.log(error);
                toast.error("حدث خطأ");
            });
    }

    getStatusBadge = (status) => {
        const config = {
            0: { text: 'غير مدققة', style: styles.badgeWarning },
            1: { text: 'انتظار', style: styles.badgeInfo },
            2: { text: 'تم الادخال', style: styles.badgeSuccess },
            3: { text: 'ملغية', style: styles.badgeError },
        };
        const c = config[status] || config[0];
        return <span style={{ ...styles.badge, ...c.style }}>{c.text}</span>;
    }

    getSanaText = (sana) => ({ 0: "قطع غيار", 1: "منزلية", 2: "موبايلات" }[sana] || "منزلية");

    renderCheckbox = (checked) => (
        <div style={{ ...styles.checkbox, ...(checked ? styles.checkboxChecked : {}) }}>
            {checked && <Icons.Check />}
        </div>
    );

    renderFilters = () => {
        const { filters, suppliers, showFilters } = this.state;

        return (
            <div style={styles.filterSection}>
                <div style={styles.filterHeader}>
                    <div style={styles.filterTitle}>
                        <Icons.Filter />
                        <span>الفلاتر</span>
                    </div>
                    <button style={styles.filterToggle} onClick={() => this.setState({ showFilters: !showFilters })}>
                        {showFilters ? 'إخفاء' : 'إظهار'}
                    </button>
                </div>

                {showFilters && (
                    <>
                        <div style={styles.filterGrid} className="filter-grid-responsive">
                            <div style={styles.filterGroup}>
                                <div style={styles.filterGroupTitle}>اسم التاجر</div>
                                <div style={styles.supplierList}>
                                    {suppliers.map(s => (
                                        <div key={s.id} style={styles.filterOption} className="filter-option"
                                            onClick={() => this.handleFilterChange('supplier_name', s.name)}>
                                            {this.renderCheckbox(filters.supplier_name.includes(s.name))}
                                            <span style={styles.filterLabel}>{s.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div style={styles.filterGroup}>
                                <div style={styles.filterGroupTitle}>النوع</div>
                                {[{ v: 0, l: 'داخلي' }, { v: 1, l: 'خارجي' }].map(i => (
                                    <div key={i.v} style={styles.filterOption} className="filter-option"
                                        onClick={() => this.handleFilterChange('type', i.v)}>
                                        {this.renderCheckbox(filters.type.includes(i.v))}
                                        <span style={styles.filterLabel}>{i.l}</span>
                                    </div>
                                ))}
                            </div>

                            <div style={styles.filterGroup}>
                                <div style={styles.filterGroupTitle}>البضاعة</div>
                                {[{ v: 0, l: 'قطع غيار' }, { v: 1, l: 'منزلية' }, { v: 2, l: 'موبايلات' }].map(i => (
                                    <div key={i.v} style={styles.filterOption} className="filter-option"
                                        onClick={() => this.handleFilterChange('sana', i.v)}>
                                        {this.renderCheckbox(filters.sana.includes(i.v))}
                                        <span style={styles.filterLabel}>{i.l}</span>
                                    </div>
                                ))}
                            </div>

                            <div style={styles.filterGroup}>
                                <div style={styles.filterGroupTitle}>الحالة</div>
                                {[{ v: 0, l: 'غير مدققة' }, { v: 1, l: 'انتظار' }, { v: 2, l: 'تم الادخال' }, { v: 3, l: 'ملغية' }].map(i => (
                                    <div key={i.v} style={styles.filterOption} className="filter-option"
                                        onClick={() => this.handleFilterChange('status', i.v)}>
                                        {this.renderCheckbox(filters.status.includes(i.v))}
                                        <span style={styles.filterLabel}>{i.l}</span>
                                    </div>
                                ))}
                            </div>

                            <div style={styles.filterGroup}>
                                <div style={styles.filterGroupTitle}>الفحص</div>
                                {[{ v: 'true', l: 'تم الفحص' }, { v: 'false', l: 'معلقة' }].map(i => (
                                    <div key={i.v} style={styles.filterOption} className="filter-option"
                                        onClick={() => this.handleFilterChange('is_closed', i.v)}>
                                        {this.renderCheckbox(filters.is_closed.includes(i.v))}
                                        <span style={styles.filterLabel}>{i.l}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div style={styles.filterActions}>
                            <button style={styles.applyButton} className="action-btn" onClick={this.applyFilters}>بحث</button>
                            <button style={styles.resetButton} className="reset-btn" onClick={this.resetFilters}>
                                <Icons.Refresh /> إعادة تعيين
                            </button>
                        </div>
                    </>
                )}
            </div>
        );
    }

    // ========== Mobile Card View ==========
    renderMobileCard = (item) => (
        <div key={item.id} style={styles.mobileCard}>
            <div style={styles.mobileCardHeader}>
                <span style={styles.mobileCardId}>#{item.id}</span>
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    {this.getStatusBadge(item.status)}
                    <span style={{ ...styles.badge, ...(item.is_closed ? styles.badgeSuccess : styles.badgeWarning) }}>
                        {item.is_closed ? 'تم' : 'معلقة'}
                    </span>
                </div>
            </div>

            <div style={styles.mobileCardBody}>
                <div style={styles.mobileCardField}>
                    <span style={styles.mobileCardLabel}>التاجر</span>
                    <span style={styles.mobileCardValue}>{item.suppliers?.name || '-'}</span>
                </div>
                <div style={styles.mobileCardField}>
                    <span style={styles.mobileCardLabel}>المبلغ</span>
                    <span style={{ ...styles.mobileCardValue, fontWeight: '700', color: '#0f172a' }}>
                        {item.t_amount?.toLocaleString()} <small style={{ color: '#94a3b8', fontWeight: '400' }}>د.ع</small>
                    </span>
                </div>
                <div style={styles.mobileCardField}>
                    <span style={styles.mobileCardLabel}>التاريخ</span>
                    <span style={styles.mobileCardValue}>{moment(item.createdAt).format('DD/MM/YYYY')}</span>
                </div>
                <div style={styles.mobileCardField}>
                    <span style={styles.mobileCardLabel}>النوع</span>
                    <span style={styles.mobileCardValue}>{item.type === 0 ? 'داخلي' : 'خارجي'}</span>
                </div>
                <div style={styles.mobileCardField}>
                    <span style={styles.mobileCardLabel}>البضاعة</span>
                    <span style={styles.mobileCardValue}>{this.getSanaText(item.sana)}</span>
                </div>
            </div>

            <div style={styles.mobileCardActions}>
                <Link to={`${item.sana === 0 ? 'InvoicePreview' : item.sana === 2 ? 'SanaBill' : 'bill'}?id=${item.id}`} style={{ textDecoration: 'none', flex: 1 }}>
                    <button style={{ ...styles.actionButton, width: '100%', justifyContent: 'center' }} className="action-btn">
                        <Icons.Info /> عرض
                    </button>
                </Link>
                {!item.is_closed && (
                    <Component initialState={{ isShown: false }}>
                        {({ state, setState }) => (
                            <Pane style={{ flex: 1 }}>
                                <Dialog
                                    isShown={state.isShown}
                                    title="غلق القائمة"
                                    intent="danger"
                                    onCloseComplete={() => setState({ isShown: false })}
                                    confirmLabel="تأكيد"
                                    cancelLabel="إلغاء"
                                    onConfirm={() => { setState({ isShown: false }); this.updateList(item.id); }}
                                >
                                    <p style={{ textAlign: 'center' }}>غلق القائمة <strong>#{item.id}</strong>؟</p>
                                </Dialog>
                                <button style={{ ...styles.closeButton, width: '100%', justifyContent: 'center' }} className="action-btn" onClick={() => setState({ isShown: true })}>
                                    <Icons.Close /> غلق
                                </button>
                            </Pane>
                        )}
                    </Component>
                )}
            </div>
        </div>
    );

    renderTable = () => {
        const { bills, loading, isMobile } = this.state;

        if (loading) {
            return (
                <div style={styles.loadingContainer}>
                    <div style={styles.spinner}></div>
                </div>
            );
        }

        if (bills.length === 0) {
            return (
                <div style={styles.emptyState}>
                    <Icons.FileText />
                    <h3 style={{ color: '#64748b', margin: '14px 0 6px', fontSize: '16px' }}>لا توجد فواتير</h3>
                    <p style={{ fontSize: '13px' }}>لم يتم العثور على فواتير مطابقة</p>
                </div>
            );
        }

        return (
            <>
                {/* Desktop Table */}
                <div className="desktop-table" style={{ display: isMobile ? 'none' : 'block' }}>
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>#</th>
                                    <th style={styles.th}>التاجر</th>
                                    <th style={styles.th}>المبلغ</th>
                                    <th style={styles.th}>التاريخ</th>
                                    <th style={styles.th}>النوع</th>
                                    <th style={styles.th}>البضاعة</th>
                                    <th style={styles.th}>الحالة</th>
                                    <th style={styles.th}>الفحص</th>
                                    <th style={styles.th}>الإجراءات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bills.map((item, idx) => (
                                    <tr key={item.id} style={{ ...styles.tr, animation: `fadeIn 0.3s ease ${idx * 0.02}s both` }} className="table-row">
                                        <td style={styles.td}>
                                            <span style={{ fontWeight: '600', color: '#2563eb' }}>#{item.id}</span>
                                        </td>
                                        <td style={styles.td}>{item.suppliers?.name || '-'}</td>
                                        <td style={styles.td}>
                                            <span style={{ fontWeight: '600' }}>{item.t_amount?.toLocaleString()}</span>
                                            <small style={{ color: '#94a3b8', marginRight: '4px' }}>د.ع</small>
                                        </td>
                                        <td style={styles.td}>{moment(item.createdAt).format('DD/MM/YYYY')}</td>
                                        <td style={styles.td}>{item.type === 0 ? 'داخلي' : 'خارجي'}</td>
                                        <td style={styles.td}>{this.getSanaText(item.sana)}</td>
                                        <td style={styles.td}>{this.getStatusBadge(item.status)}</td>
                                        <td style={styles.td}>
                                            <span style={{ ...styles.badge, ...(item.is_closed ? styles.badgeSuccess : styles.badgeWarning) }}>
                                                {item.is_closed ? 'تم' : 'معلقة'}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                <Link to={`${item.sana === 0 ? 'InvoicePreview' : item.sana === 2 ? 'SanaBill' : 'bill'}?id=${item.id}`} style={{ textDecoration: 'none' }}>
                                                    <button style={styles.actionButton} className="action-btn">
                                                        <Icons.Info /> عرض
                                                    </button>
                                                </Link>
                                                {!item.is_closed && (
                                                    <Component initialState={{ isShown: false }}>
                                                        {({ state, setState }) => (
                                                            <Pane>
                                                                <Dialog
                                                                    isShown={state.isShown}
                                                                    title="غلق القائمة"
                                                                    intent="danger"
                                                                    onCloseComplete={() => setState({ isShown: false })}
                                                                    confirmLabel="تأكيد"
                                                                    cancelLabel="إلغاء"
                                                                    onConfirm={() => { setState({ isShown: false }); this.updateList(item.id); }}
                                                                >
                                                                    <p style={{ textAlign: 'center' }}>غلق القائمة <strong>#{item.id}</strong>؟</p>
                                                                </Dialog>
                                                                <button style={styles.closeButton} className="action-btn" onClick={() => setState({ isShown: true })}>
                                                                    <Icons.Close /> غلق
                                                                </button>
                                                            </Pane>
                                                        )}
                                                    </Component>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Mobile Cards */}
                <div className="mobile-cards" style={{ display: isMobile ? 'block' : 'none', padding: '12px' }}>
                    {bills.map(item => this.renderMobileCard(item))}
                </div>
            </>
        );
    }

    renderPagination = () => {
        const { currentPage, totalPages, total, limit } = this.state;
        if (totalPages <= 1) return null;

        const pages = [];
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + 4);
        if (end - start < 4) start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);

        return (
            <div style={styles.paginationContainer} className="pagination-wrap">
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(1)} disabled={currentPage === 1}>
                    <Icons.ChevronsRight />
                </button>
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    <Icons.ChevronRight />
                </button>

                {start > 1 && <span style={styles.pageInfo}>...</span>}

                {pages.map(p => (
                    <button key={p}
                        style={{ ...styles.pageButton, ...(p === currentPage ? styles.pageButtonActive : {}) }}
                        className={`page-btn ${p === currentPage ? 'active' : ''}`}
                        onClick={() => this.handlePageChange(p)}
                    >{p}</button>
                ))}

                {end < totalPages && <span style={styles.pageInfo}>...</span>}

                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    <Icons.ChevronLeft />
                </button>
                <button style={styles.pageButton} className="page-btn" onClick={() => this.handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                    <Icons.ChevronsLeft />
                </button>

                <span style={styles.pageInfo}>
                    {((currentPage - 1) * limit) + 1} - {Math.min(currentPage * limit, total)} من {total}
                </span>
            </div>
        );
    }

    render() {
        if (!cookies.get("token")) return <Login />;
        const { total, currentPage, totalPages } = this.state;

        return (
            <Context.Consumer>
                {ctx => (
                    <div style={styles.container} className="page-container">
                        {/* Header */}
                        <div style={styles.header}>
                            <h1 style={styles.pageTitle}>
                                <Icons.Receipt />
                                <span className="page-title-text">إدارة الفواتير</span>
                            </h1>
                            <Component initialState={{ isShown: false }}>
                                {({ state, setState }) => (
                                    <Pane>
                                        <Dialog
                                            isShown={state.isShown}
                                            title="إنشاء فاتورة جديدة"
                                            onCloseComplete={() => setState({ isShown: false })}
                                            confirmLabel="إنشاء"
                                            cancelLabel="إلغاء"
                                            onConfirm={() => {
                                                window.location.href = this.state.selectedBillType === '3'
                                                    ? `/NewPartsBill`
                                                    : `/newbill?type=${this.state.selectedBillType}`;
                                            }}
                                        >
                                            <div style={{ direction: 'rtl' }}>
                                                <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '14px', fontSize: '14px' }}>اختر نوع الفاتورة</p>
                                                <div style={styles.radioGroup}>
                                                    {[{ v: '1', l: 'منزلية' }, { v: '2', l: 'موبايلات' }, { v: '3', l: 'قطع غيار' }].map(o => (
                                                        <div key={o.v}
                                                            style={{ ...styles.radioOption, ...(this.state.selectedBillType === o.v ? styles.radioOptionSelected : {}) }}
                                                            onClick={() => this.setState({ selectedBillType: o.v })}
                                                        >
                                                            <div style={{
                                                                width: '14px', height: '14px', borderRadius: '50%',
                                                                border: `2px solid ${this.state.selectedBillType === o.v ? '#2563eb' : '#cbd5e1'}`,
                                                                background: this.state.selectedBillType === o.v ? '#2563eb' : '#fff',
                                                            }} />
                                                            <span style={{ color: '#334155', fontSize: '14px' }}>{o.l}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Dialog>
                                        <button style={styles.createButton} className="create-btn" onClick={() => setState({ isShown: true })}>
                                            <Icons.Plus /> إنشاء فاتورة
                                        </button>
                                    </Pane>
                                )}
                            </Component>
                        </div>

                        {/* Stats */}
                        <div style={styles.statsContainer} className="stats-grid">
                            <div style={styles.statCard} className="stat-card">
                                <div style={{ ...styles.statValue, color: '#2563eb' }} className="stat-value">{total}</div>
                                <div style={styles.statLabel}>إجمالي الفواتير</div>
                            </div>
                            <div style={styles.statCard} className="stat-card">
                                <div style={{ ...styles.statValue, color: '#10b981' }} className="stat-value">{this.state.limit}</div>
                                <div style={styles.statLabel}>لكل صفحة</div>
                            </div>
                            <div style={styles.statCard} className="stat-card">
                                <div style={{ ...styles.statValue, color: '#f59e0b' }} className="stat-value">{currentPage}</div>
                                <div style={styles.statLabel}>الصفحة الحالية</div>
                            </div>
                            <div style={styles.statCard} className="stat-card">
                                <div style={{ ...styles.statValue, color: '#8b5cf6' }} className="stat-value">{totalPages}</div>
                                <div style={styles.statLabel}>عدد الصفحات</div>
                            </div>
                        </div>

                        {/* Filters */}
                        {this.renderFilters()}

                        {/* Table / Cards */}
                        <div style={styles.tableContainer}>
                            {this.renderTable()}
                            {this.renderPagination()}
                        </div>

                        <ToastContainer position="bottom-left" autoClose={4000} rtl theme="light" />
                    </div>
                )}
            </Context.Consumer>
        );
    }
}

export default Selles_Reports;
